import { useState, useCallback } from "react";
import { filterDataByTeam, getCSRFToken, fetchWithAuth } from "../../auth";

export const useFetch = () => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const fetchData = useCallback(async (endpoint, callback) => {
        try {
            setLoaded(false);
            setError('');
            setSuccess(false);
            const response = await fetchWithAuth(
                `${process.env.REACT_APP_ICC_TOOL_API_HOST}${endpoint}`,
                {
                    headers: { 'X-CSRFToken': getCSRFToken() },
                    credentials: 'include',
                }
            );
            const data = await response.json();
            if (!data) throw new Error('Failed to fetch response');
            callback(data);
            setSuccess(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoaded(true);
        }
    }, []);

    return { fetchData, loaded, error, success, setError, setSuccess, setLoaded };
};

export const useTeams = (fetchData) => {
    const [teams, setTeams] = useState([]);
    const [team, setTeam] = useState({});

    const getTeams = useCallback(async () => {
        await fetchData('user/teams/', (data) => {
            const userInfo = filterDataByTeam();
            const filteredTeams = userInfo?.filterData
                ? data.filter((team) => team.members.includes(userInfo.name))
                : data;
            setTeams(filteredTeams);
            if (filteredTeams.length > 0) setTeam(filteredTeams[0]);
        });
    }, [fetchData]);

    const getTeamDetails = useCallback(async (id) => {
        await fetchData(`teams/${id}/`, setTeam);
    }, [fetchData]);

    return { teams, team, setTeam, getTeams, getTeamDetails };
};

export const useJSAForms = (fetchData) => {
    const [jsaForms, setJSAForms] = useState({});

    const getJSAForms = useCallback(async () => {
        await fetchData(`jsa/forms/`, (data) => {
            const forms = data.reduce((acc, form) => {
                acc[form.id] = form;
                return acc;
            }, {});
            setJSAForms(forms);
        });
    }, [fetchData]);

    return { jsaForms, setJSAForms, getJSAForms };
};